import _ from 'lodash'

import { DynamicFieldData, SelectOption } from '@/shared/components/DynamicForm/models/DynamicFieldData'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FormFieldDefaultValue = Record<string, any> // Map between form fieldName and Default Value
export type FormFieldSelectOptions = Record<string, SelectOption[]> // Map between form field name and select options

export type GetDynamicFormFieldsArgs = {
  fields: DynamicFieldData[]
  defaultValues?: FormFieldDefaultValue
  selectOptions?: FormFieldSelectOptions
}

export const getDynamicFormFields = ({ fields, defaultValues, selectOptions }: GetDynamicFormFieldsArgs): DynamicFieldData[] => {
  const formFields: DynamicFieldData[] = _.cloneDeep(fields)

  // Inject select and multiselect options to the fields
  formFields.forEach((field) => {
    const fieldName = field.fieldName

    if (selectOptions && (field.fieldType === 'select' || field.fieldType === 'multiselect') && selectOptions[fieldName]) {
      field.options = selectOptions[fieldName]
    }

    if (defaultValues && defaultValues[fieldName] !== undefined) {
      field.defaultValue = defaultValues[fieldName]
    }
  })

  return formFields
}